// src/utils/parsers/integralParser.js
import * as pdfjsLib from 'pdfjs-dist';
import { standardizeStockData } from './fileUtils';

pdfjsLib.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

export const parseIntegralPDF = async (file) => {
  try {
    const fileBuffer = await file.arrayBuffer();
    const loadingTask = pdfjsLib.getDocument(new Uint8Array(fileBuffer));
    const pdf = await loadingTask.promise;
    const page = await pdf.getPage(1);
    const textContent = await page.getTextContent();
    const text = textContent.items.map(item => item.str).join(' ');

    // Hisse-Fon-Repo Bilgileri bölümünü bul
    const stockSectionStart = text.indexOf('Hisse-Fon-Repo Bilgileri');
    const stockSectionEnd = text.indexOf('Cash Valuation', stockSectionStart);
    
    if (stockSectionStart === -1) {
      throw new Error('Hisse senedi bilgileri bulunamadı');
    }
    
    const stockSection = text.slice(stockSectionStart, stockSectionEnd);
    
    // Regex pattern for stock data
    const stockPattern = /([A-Z]+)\s+([\d.,<>]+)\s+([\d.,]+)\s+([\d.,]+)\s+[\d.,<>]+\s+[\d.,<>]+\s+([\d.,]+)\s+(-?[\d.,]+)/g;
    
    const stocks = [];
    let match;

    while ((match = stockPattern.exec(stockSection)) !== null) {
      try {
        // Remove <Küsurat> and similar brackets
        let shares = match[2].replace(/<.*?>/g, '').replace('.', '');
        
        const rawStock = {
          symbol: match[1],
          shares: parseInt(shares, 10),
          price: match[3],
          total: match[4],
          cost: match[5],
          profitLoss: match[6]
        };

        const stock = standardizeStockData(rawStock);
        
        // Validate stock data
        if (stock.symbol && stock.shares > 0 && stock.price > 0) {
          stocks.push(stock);
        }
      } catch (error) {
        console.error('Error processing stock entry:', match, error);
      }
    }

    if (stocks.length === 0) {
      throw new Error('İşlenebilir hisse senedi verisi bulunamadı');
    }

    return stocks;
    
  } catch (error) {
    console.error('PDF parse error:', error);
    throw new Error(`PDF dosyası işlenirken hata oluştu: ${error.message}`);
  }
};